import { useInfiniteQuery, useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Button } from '@upme/ui/components/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@upme/ui/components/select';
import { useState } from 'react';
import { listCitiesOptions } from '../../../../features/cities/queries';
import { FakesTable } from '../../../../features/users/components/fakes-table';
import { listFakesInfiniteOptions } from '../../../../features/users/queries';
import { EmptyState } from '../../../../shared/components/empty-state';
import { PageHeader } from '../../../../shared/components/page-header';

const ALL_CITIES = '__all__';

export const Route = createFileRoute('/_authenticated/users/fakes/')({
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureInfiniteQueryData(listFakesInfiniteOptions()),
      context.queryClient.ensureQueryData(listCitiesOptions()),
    ]);
  },
  component: FakesIndexPage,
});

function FakesIndexPage() {
  const [cityId, setCityId] = useState<string | undefined>(undefined);
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isPending } = useInfiniteQuery(
    listFakesInfiniteOptions(cityId ? { cityId } : {}),
  );
  const { data: cities } = useSuspenseQuery(listCitiesOptions());
  const cityNameById = new Map(cities.map((c) => [c.id, c.name]));

  const items = data?.pages.flatMap((p) => p.items) ?? [];

  return (
    <div className="space-y-6">
      <PageHeader
        title="Фейковые аккаунты"
        description="Массовка для networking-колоды. Видны в deck'е только при NETWORKING_INCLUDE_FAKES=true."
      />
      <div className="flex flex-wrap items-center gap-2">
        <Button asChild>
          <Link to="/users/fakes/new">Создать фейк</Link>
        </Button>
        <Button asChild variant="outline">
          <Link to="/users">← К пользователям</Link>
        </Button>
        <Select
          value={cityId ?? ALL_CITIES}
          onValueChange={(v) => setCityId(v === ALL_CITIES ? undefined : v)}
        >
          <SelectTrigger className="w-56">
            <SelectValue placeholder="Все города" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL_CITIES}>Все города</SelectItem>
            {cities.map((c) => (
              <SelectItem key={c.id} value={c.id}>
                {c.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {isPending ? (
        <p className="text-sm text-muted-foreground">Загрузка…</p>
      ) : items.length === 0 ? (
        <EmptyState title="Фейков пока нет" />
      ) : (
        <>
          <FakesTable items={items} cityNameById={cityNameById} />
          <div className="flex items-center justify-center gap-3">
            <span className="text-sm text-muted-foreground">Показано: {items.length}</span>
            {hasNextPage && (
              <Button variant="outline" disabled={isFetchingNextPage} onClick={() => fetchNextPage()}>
                {isFetchingNextPage ? 'Загрузка…' : 'Загрузить ещё'}
              </Button>
            )}
          </div>
        </>
      )}
    </div>
  );
}
